import { render, staticRenderFns } from "./RatebaseDetail.vue?vue&type=template&id=67d2e46a&scoped=true&"
import script from "./RatebaseDetail.vue?vue&type=script&lang=js&"
export * from "./RatebaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2e46a",
  null
  
)

export default component.exports